import React, { useState ,useContext} from 'react'
import {AppFormItemProps,AppFormContext,AppFormItemEnum} from '../AppForm/index'
import {MetadataOption} from 'api'
import {appDate,appNumber} from 'utils'


export const AppFormItemLabel = (props:AppFormItemProps) =>{
    
    const {formData} = useContext(AppFormContext);
   
    const getText = () =>{
        let {textKeyName,keyName,dataType,format,itemType} = props;
        let key = textKeyName || keyName;

        if(itemType===AppFormItemEnum.select || itemType === AppFormItemEnum.radio){
           return getOptionText(`${formData[key]}`,props.options)
        }

        return appFormat(dataType,formData[key],format);
    }

    return <label key={getText()} className='app-from-item-label'> {getText()}</label>
}



const appFormat = (dataType?:string,value?:string | number,fmt?:string) =>{
    if(value !== null && value !== undefined && value === 0) value = '0'
    let stringValue = `${value||''}`;
    if(dataType === 'number') return appNumber.format(stringValue,fmt);
    if(dataType === 'date' || dataType === 'datetime' ) return appDate.format(stringValue,fmt);
    return stringValue; 
}



const getOptionText = (value?: string, options?: MetadataOption[]) => {
	options = getOptions(options)
	let option = options.find(o => o.value === value) || { label: '' }
	return option.label || ''
}

const getOptions = (options?: MetadataOption[]) => {
	if (options) {
		return options.map((option: MetadataOption) => {
			return { label: option.label || '', value: option.value || '' }
		})
	}
	return [{ label: '是', value: '1' }, { label: '否', value: '0' }]
}


// WEBPACK FOOTER //
// ./src/qcc/AppFormItem/AppFormItemLabel.tsx